import { render, staticRenderFns } from "./TotalSaleByPeriodAndDepartment.vue?vue&type=template&id=410a2cd0"
import script from "./TotalSaleByPeriodAndDepartment.vue?vue&type=script&lang=js"
export * from "./TotalSaleByPeriodAndDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports